

export const recursiveUpdate = async (functionParameters = {}) => {

    const axios = (await import(/* webpackPrefetch: true */ "axios")).default;

    const { displayAndStoreSmartboxWithPreloader } = (await import(/* webpackPrefetch: true */ "../../display/displayAndStoreSmartboxWithPreloader.js"));
    const { isEmpty } = (await import(/* webpackPrefetch: true */ "@schaniag/sharedfunctions"));
    
    const { appClass, isCopying, token, submissionData, modelPath, sideMenuToUse, submissionFuncPath,  title, doNotSaveFormData, addToSubmissionData } = functionParameters;
    let { url, urlDestination, smartboxStorageName } = functionParameters;

    const smartBoxTitle = title || "";

    const { preloader, smetioSmartbox, backBtnIsClicked } = await displayAndStoreSmartboxWithPreloader({ title: smartBoxTitle, smartboxStorageName });
     
    if (!("values" in window[smartboxStorageName])) window[smartboxStorageName]["values"] = {};

    const { formData } = submissionData;
      
    if(doNotSaveFormData !== true ) {
        for (const key in formData) { window[smartboxStorageName]["values"][key] = formData[key]; };
    };

    submissionData["values"] = window[smartboxStorageName]["values"];

    const previousPreloader = functionParameters.preloader;
    previousPreloader.show();

    const previousSmartbox = functionParameters.smetioSmartbox;
    previousSmartbox.hide();

    const apiEndPoint = window.apiEndPoint;
    const language = window.userLanguage;
    const sideMenuItems = window.currentSideMenuItems;

    preloader.show();

    urlDestination = urlDestination || "update";
    url = url || `${apiEndPoint}/apps/${appClass.appUserInterface}/${sideMenuToUse}/${urlDestination}/${language}`;

    if(Array.isArray(modelPath)){
        submissionData["formData"] = {...formData, ...window[smartboxStorageName]["values"] };
    }

    await axios.post(url, { modelPath, token, ...submissionData, ...addToSubmissionData }).then(async (response) => {

        let model = response.data;

        if (model.error) {
            console.log(" I AM CLICKING BACK 11111111111111111111111111111");
            backBtnIsClicked();
            previousSmartbox.show(); return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: model.msg }] });
        };

        const { nextStep, modelPath, instructionTitle, instructionSubtitle, token, updateCompleted, refreshPage, doNotShowCongrate, newSubmissionFuncPath, addToSubmissionData, submitText, doNotSaveFormData, fallbackFunctionDetails } = model;
        model = model.model;

        const {getCongratulationsSmartbox} = (await import(/* webpackPrefetch: true */ "../../get/getCongratulationsSmartbox.js"));

        const { newVersionOfConvertModelToInputs } = (await import(/* webpackPrefetch: true */ "./../../../classes/universal_methods/newVersionOfConvertModelToInputs.js"));

        if (typeof fallbackFunctionDetails === "object" && fallbackFunctionDetails !== null && fallbackFunctionDetails !== undefined) {
            
            fallbackFunctionDetails["preloaderClass"] = preloader;

            const { getAndCallFallbackFunction } = (await import(/* webpackPrefetch: true */ "../../get/getAndCallFallbackFunction.js"));
            await getAndCallFallbackFunction(fallbackFunctionDetails).catch((err) => {
                console.log("Here is the error from  getAndCallFallbackFunction  ", err);
            });

        };

        if (refreshPage === true) sideMenuItems[sideMenuToUse].onClick();

        if (nextStep === "congratutions" || updateCompleted === true) {

            smetioSmartbox.close();

            return doNotShowCongrate !== false && doNotShowCongrate !== undefined ? false : await getCongratulationsSmartbox({ txt: instructionSubtitle });

        };

        const confirmationInput = await newVersionOfConvertModelToInputs({
            model,
            withSubmitButton: nextStep === "congratutions" ? false : true,
            withFullContainerDiv: true,
            submitText: submitText || "txt38",
            doNotShowInstruction: instructionSubtitle ? false : true,
            instructionTitle: instructionTitle || "",
            instructionSubtitle: instructionSubtitle || "",
            submissionFunctionDetails: {
                functionPath: !isEmpty(newSubmissionFuncPath) ? newSubmissionFuncPath : submissionFuncPath,
                functionParameters: {
                    appClass,
                    preloader,
                    smetioSmartbox,
                    modelPath,
                    smartboxStorageName,
                    token,
                    isCopying,
                    url,
                    sideMenuToUse,
                    title,
                    doNotSaveFormData,
                    ...addToSubmissionData
                },
                addToSubmissionData: { ...addToSubmissionData, isCopying, token }
            },
            showBackBtn: nextStep === "addToSkillset" || nextStep === "congratutions" ? false : true,
            onBackBtnClicked: () => {
                console.log(" I AM CLICKING BACK #########");
                backBtnIsClicked();
            },
        });

        const newPreloaderDisplay = preloader.render();

        const content = `
          ${newPreloaderDisplay}
          ${confirmationInput}
        `;
        preloader.hide();

        smetioSmartbox.updateContent(content);

    }).catch((error) => {

        console.log(error);
        previousSmartbox.show();
        console.log(" I AM CLICKING BACK ====================");
        backBtnIsClicked();
        return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: "txt423" }] });

    }).finally(() => {
        previousPreloader.hide();
    });




};
